import { Box } from '@mui/material';

export const Hospital = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
